import { gql } from '@apollo/client'

export const boostForestMutation = gql`
  mutation boostForest($coins: Int!, $drops: Int!) {
    boostForest(input: { coins: $coins, drops: $drops }) {
      coins
      waterDropDetails {
        currentDrops
      }
    }
  }
`
